import React, {Component, useState, useContext} from 'react';
import {BrowserRouter, Routes, Route, useLocation, Navigate} from 'react-router-dom';
import { /*RoutePrivate,*/ RouteRestricted } from './utils/routes';
import {UserContext, UserProvider} from './utils/usercontext';
import Socket from './utils/socket';
import Donation from './routes/components/donation/donation';
import Notifications from './routes/components/notifications/notifications';
import Fault from './routes/components/fault/fault';


//---- Main components
import Header from './routes/header';
import Footer from './routes/footer';

//---- Pages
import Index from './routes/index';
import About from './routes/about';
import Events from './routes/events';
import Mix365djs from './routes/mix365djs';
import PreviousSet from './routes/previousset';
import PreviousSets from './routes/previoussets';
import Listen from './routes/listen';
import Schedule from './routes/schedule';
import LiveClubbers from './routes/live';
import LiveRadio from './routes/live';
import LiveHyper from './routes/live';
import LiveEvolution from './routes/live';
import MChat from './routes/mchat';
import Contact from './routes/contact';
import Advertise from './routes/advertise';
import Apply from './routes/apply';
import Shop from './routes/shop';
import Profile from './routes/profile';
import Settings from './routes/settings';
import Privacy from './routes/privacy';
import House from './routes/house';
import Trance from './routes/trance';
import Techno from './routes/techno';
import OldSkool from './routes/oldskool';


//---- Hidden pages
//import Dropbox from './routes/dropbox';
import Twitch from './routes/twitch';

//---- User pages
import Loading from './routes/loading';
import Login from './routes/login';
import Logout from './routes/logout';
import Register from './routes/register';
import Recover from './routes/recover';
import Verify from './routes/verify';

//---- DJ Area
import DJArea from './routes/djarea/index';
import DJAreaCompetition from './routes/djarea/competition';
import DJAreaConnection from './routes/djarea/connection';
import DJAreaTest from './routes/djarea/test';
import DJAreaFiles from './routes/djarea/files';
import DJAreaTemplates from './routes/djarea/templates';
import DJAreaMembers from './routes/djarea/members';
import DJAreaSocials from './routes/djarea/socials';
import DJAreaPosters from './routes/djarea/posters';
import DJAreaStatistics from './routes/djarea/statistics';
import DJAreaLogs from './routes/djarea/logs';

//---- Admin
import Admin from './routes/admin/index';
import AdminDJAccounts from './routes/admin/djaccounts';
import AdminEvents from './routes/admin/events';
import AdminWeekly from './routes/admin/weekly';
import AdminPublish from './routes/admin/publish';
import AdminPrevious from './routes/admin/previoussets';
import AdminSEO from './routes/admin/seo';
import AdminAuth from './routes/admin/auth';
import AdminAuthConfirm from './routes/admin/authconfirm';


//---- CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './routes/css/website.css';


const ViewWebsite = (props) => {
  const value = useContext(UserContext);
  if( !value.user.user ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Loading />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    return (
      <>
        {props.children}
      </>
    )
  }
}


export default function App() {
  /*const location = useLocation();
  const [header, setHeader] = useState(true);
  
  React.useEffect(() => {
    if(location.pathname) setHeader(location.pathname.split('/')[1]==='mchat'?false:true);
  }, [location]);*/

  return (
    <>
      <UserProvider>
        <ViewWebsite>
          <BrowserRouter>
            {(window.location.pathname.indexOf('/mchat')===-1)&&<Header />}
            <Routes>
		<Route path="/radio/house" element={<House />} />
		  <Route path="/radio/trance" element={<Trance />} />
		  <Route path="/radio/techno" element={<Techno />} />
		  <Route path="/radio/oldskool" element={<OldSkool />} />
              <Route path="/" exact element={<Index />} />
              <Route path="/about" exact element={<About />} />
              <Route path="/events/:id" element={<Events />} />
              <Route path="/mix365djs" exact element={<Mix365djs />} />
              <Route path="/previous-sets" exact element={<PreviousSets />} />
              <Route path="/listen" exact element={<Listen />} />
              <Route path="/schedule" exact element={<Schedule />} />
              <Route path='/live' element={ <Navigate to="/hyper" /> }/>
              <Route path='/live/:id' element={ <Navigate to="/hyper" /> }/>
              {/*<Route path="/clubbers/schedule" exact element={<Schedule />} />*/}
              <Route path="/clubbers" exact element={<Navigate to="/hyper" />} />
              <Route path="/clubbers/:id" exact element={<Navigate to="/hyper" />} />
              {/*<Route path="/radio/schedule" exact element={<Schedule />} />*/}
              <Route path="/radio" exact element={<Navigate to="/evolution" />} />
              <Route path="/radio/:id" exact element={<Navigate to="/evolution" />} />
              <Route path="/hyper/schedule" exact element={<Schedule />} />
              <Route path="/hyper" exact element={<LiveHyper key={Date.now()} />} />
              <Route path="/hyper/:id" exact element={<LiveHyper key={Date.now()} />} />
              <Route path="/evolution/schedule" exact element={<Schedule />} />
              <Route path="/evolution" exact element={<LiveEvolution key={Date.now()} />} />
              <Route path="/evolution/:id" exact element={<LiveEvolution key={Date.now()} />} />
              <Route path="/mchat" exact element={<MChat />} />
              <Route path="/mchat/:id" element={<MChat />} />
              <Route path="/contact" exact element={<Contact />} />
              <Route path="/advertise" exact element={<Advertise />} />
              <Route path="/apply" exact element={<Apply />} />
              <Route path="/shop" exact element={<Shop />} />
              
              <Route path="/settings/:id" exact element={<Settings key={Date.now()} />} />
              <Route path="/privacy" exact element={<Privacy />} />

              <Route path="/snitch" exact element={<Twitch />} />

              <Route path="/login" exact element={<Login return="" />} />
              <Route path="/logout" exact element={<Logout />} />
              <Route path="/register" exact element={<Register />} />
              <Route path="/register/:code" exact element={<Register />} />
              <Route path="/recover" exact element={<Recover />} />
              <Route path="/recover/:key" exact element={<Recover />} />
              <Route path="/verify/:key" exact element={<Verify />} />

              <Route path="/djarea" exact element={<RouteRestricted page="mod" />}>
                <Route path="/djarea" exact element={<DJArea />} />
                <Route path="/djarea/competition" exact element={<DJAreaCompetition />} />
                <Route path="/djarea/connection" exact element={<DJAreaConnection />} />
                <Route path="/djarea/test" exact element={<DJAreaTest />} />
                <Route path="/djarea/files" exact element={<DJAreaFiles />} />
                <Route path="/djarea/templates" exact element={<DJAreaTemplates />} />
                <Route path="/djarea/members" exact element={<DJAreaMembers />} />
                <Route path="/djarea/socials" exact element={<DJAreaSocials />} />
                <Route path="/djarea/posters" exact element={<DJAreaPosters />} />
                <Route path="/djarea/statistics" exact element={<DJAreaStatistics />} />
                <Route path="/djarea/logs" exact element={<DJAreaLogs />} />
              </Route>

              <Route path="/admin" exact element={<RouteRestricted page="admin" />}>
                <Route path="/admin" exact element={<Admin />} />
                <Route path="/admin/djaccounts" exact element={<AdminDJAccounts />} />
                <Route path="/admin/events" exact element={<AdminEvents />} />
                <Route path="/admin/weekly" exact element={<AdminWeekly />} />
                <Route path="/admin/publish" exact element={<AdminPublish />} />
                <Route path="/admin/previous" exact element={<AdminPrevious />} />
                <Route path="/admin/seo" exact element={<AdminSEO />} />
                <Route path="/admin/auth" exact element={<AdminAuth />} />
              </Route>

              <Route path="/auth" exact >
                <Route path="/auth/:id" element={<AdminAuthConfirm />} />
              </Route>

              <Route path="/:id" exact element={<Profile key={Date.now()} />} />
              <Route path="/:id/:show" exact element={<PreviousSet />} />

            </Routes>
            {(window.location.pathname.indexOf('/mchat')===-1)&&<Footer />}
            <Socket />
            <Donation />
            {/*<Notifications />*/}
            <Fault />
          </BrowserRouter>
        </ViewWebsite>
      </UserProvider>
    </>
  );
};

